import { render, staticRenderFns } from "./ModalCookies.vue?vue&type=template&id=7cb1185a&scoped=true"
import script from "./ModalCookies.vue?vue&type=script&lang=js"
export * from "./ModalCookies.vue?vue&type=script&lang=js"
import style0 from "./ModalCookies.vue?vue&type=style&index=0&id=7cb1185a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb1185a",
  null
  
)

export default component.exports